import { SiteConfig, SiteIds } from '@navent-jobs/config'

declare const window: any

const { REACT_APP_ENVIRONMENT } = process.env
const SITE_ID = window.SITE_ID ?? process.env.REACT_APP_SITE_ID

if (!SITE_ID) {
  throw new Error('You must provide an env variable for REACT_APP_SITE_ID')
}

const siteConfig = SiteConfig[SITE_ID]

// **Constantes** que se deducen de SITE_ID al hacer build
const IS_ZONA_JOBS = SITE_ID === SiteIds.ZJAR
const NOMBRE_SITIO = siteConfig.nombre
const ID_PAIS = siteConfig.pais.id
const NOMBRE_PAIS = siteConfig.pais.nombre

const PORTAL_THEME = IS_ZONA_JOBS ? SiteConfig.ZJAR.nombre.toLowerCase() : SiteConfig.BMAR.nombre.toLowerCase()

const ASSETS_URL = REACT_APP_ENVIRONMENT === '1' ? `/${PORTAL_THEME}/` : `/company/${PORTAL_THEME}/`

const BASE_URL = `${window.location.protocol}//${window.location.host}`

/* interface Constants {
  SiteIds: { [x: string]: string }
  SITE_ID: string
  NOMBRE_SITIO: string
  IS_ZONA_JOBS: boolean
  ID_PAIS: number
  NOMBRE_PAIS: string
  ASSETS_URL: string
  PORTAL_THEME: string
} */

export { SiteIds, SITE_ID, NOMBRE_SITIO, IS_ZONA_JOBS, ID_PAIS, NOMBRE_PAIS, ASSETS_URL, PORTAL_THEME, BASE_URL }
